import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import novaArkImage from '../Logo.jpg';
import novaArkTitle from '../Title.jpg';
import Typography from '@mui/material/Typography';

export default function PortalNav() {
  return (
    <AppBar position="relative" elevation={0} sx={{ backgroundColor: 'white' }}>
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          px: { xs: 2, sm: 3, md: 5 },
          py: 1,
        }}
      >
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          {/* Logo */}
          <Box sx={{ display: 'inline-flex', mr: 2 }}>
            <Box
              component="img"
              src={novaArkImage}
              alt="NovaArk Logo"
              sx={{
                width: { md: '120px', sm: '100px', xs: '100px' },
                height: { md: '100px', sm: '75px', xs: '75px' },
                objectFit: 'contain',
              }}
            />
          </Box>

          {/* Title */}
          <Box sx={{ display: 'inline-flex' }}>
            <Box
              component="img"
              src={novaArkTitle}
              alt="NovaArk Title"
              sx={{
                width: { md: '250px', sm: '200px', xs: '200px' },
                height: { md: '120px', sm: '75px', xs: '75px' },
                objectFit: 'contain',
              }}
            />
          </Box>
        </Link>
        <Box>
          <Button
            startIcon={<ContactMailIcon />}
            sx={{ fontSize: { xs: '0.8rem', sm: '1rem', color: 'rgba(0, 0, 0, 0.7)' }, textTransform: 'lowercase' }}
          >
            connect@novaarktechlabs.com
          </Button>
          <Button
            startIcon={<LocalPhoneIcon />}
            sx={{ fontSize: { xs: '0.8rem', sm: '1rem', color: 'rgba(0, 0, 0, 0.7)' } }}
          >
            +91 81250 73777
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
